// extracted by mini-css-extract-plugin
export default {"hideTooltip":"w--z","fadeIn":"x--z","delay":"y--z","recommendedSizeTooltip":"z--z"};